import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Offer } from '../../../models/offer.model';
import { SharedService } from '../../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-offer-rejection-modal',
  templateUrl: './offer-rejection-modal.component.html',
  styleUrls: ['../modal.component.scss'],
})
export class OfferRejectionModalComponent implements OnInit {
  @Input() offer: Offer;
  @Input() title: string;
  @Input() isRejection: boolean;
  rejectionForm: FormGroup;
  rejectionReasons = this.sharedService.getOfferRejectionReasonsList();
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private fb: FormBuilder, private sharedService: SharedService) {}

  ngOnInit(): void {
    this.initForm();

    if (this.offer && this.isRejection) {
      this.rejectionForm.patchValue(this.offer);

      if (Array.isArray(this.offer.rejectionReasons)) {
        this.rejectionReasonArray.clear();
        this.offer.rejectionReasons.forEach(reason => {
          this.rejectionReasonArray.push(new FormControl(reason));
        });
      }
    }
  }

  initForm(): void {
    this.rejectionForm = this.fb.group({
      rejectionReasons: this.fb.array([], Validators.required),
      rejectionComment: ['', Validators.required],
    });
  }

  onCheckboxChange(event: any) {
    const formArray: FormArray = this.rejectionReasonArray;
    const selectedValue = event.target.value;

    if (event.target.checked) {
      formArray.push(new FormControl(selectedValue));
    } else {
      const index = formArray.controls.findIndex(x => x.value === selectedValue);
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
  }

  emitTrue(): void {
    this.responseChanged.emit(this.rejectionForm.value);
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }

  get rejectionReasonArray(): any {
    return this.rejectionForm.get('rejectionReasons') as FormArray;
  }
}